"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerInquiryKind = void 0;
/**
 * Whether a partner inquiry's loan application starts as a partner inquiry, which becomes an application once the
 * borrower takes the file over from the loan officer, or is an application from the start.
 */
var PartnerInquiryKind;
(function (PartnerInquiryKind) {
    PartnerInquiryKind["inquiry"] = "inquiry";
    PartnerInquiryKind["application"] = "application";
})(PartnerInquiryKind || (exports.PartnerInquiryKind = PartnerInquiryKind = {}));
